import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-150"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.593 3.407a6.626 6.626 0 0 0 .3 2.636A6.524 6.524 0 0 0 9.95 10.19a6.61 6.61 0 0 0 2.181.378 6.306 6.306 0 0 0 .666-.036A5.229 5.229 0 0 1 8.384 13c-.1 0-.202-.003-.303-.009a5.208 5.208 0 0 1-2.488-9.584M6.264 2a.486.486 0 0 0-.182.036 6.204 6.204 0 0 0-3.878 6.137 6.276 6.276 0 0 0 5.82 5.817c.12.007.24.01.36.01a6.193 6.193 0 0 0 5.775-3.968.5.5 0 0 0-.48-.671.537.537 0 0 0-.14.019 5.366 5.366 0 0 1-1.408.189 5.595 5.595 0 0 1-1.851-.322 5.56 5.56 0 0 1-3.542-6.612A.505.505 0 0 0 6.264 2z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }